import {Link, LinkProps} from 'react-router-dom'
import styled, {css} from 'styled-components'
import {fontCSS} from '../css'

/**
 * WIP here, this file should eventually replace components/library/buttons
 */

const xsmall = css`
  height: 20px;
  padding: 2px 6px;
  gap: 4px;
  ${fontCSS}
`

const small = css`
  height: 24px;
  padding: 2px 8px;
  gap: 4px;
  ${fontCSS}
`

const medium = css`
  height: 30px;
  padding: 5px 8px;
  gap: 6px;
  ${fontCSS}
`

const large = css`
  height: 40px;
  padding: 10px 12px;
  gap: 8px;
  ${fontCSS}
  font-weight: 600;
`

const rounded = css`
  border-radius: 200px;
  padding: 2px 10px;
`

const raised = css`
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2);
`

const primary = css`
  background-color: ${({theme}) => theme.colors.blue11};
  color: ${({theme}) => theme.white};
  &:hover {
    background-color: ${({theme}) => theme.colors.blue12};
  }
  &:active {
    background-color: ${({theme}) => theme.colors.blue13};
  }
  &:disabled {
    background-color: ${({theme}) => theme.colors.grey8};
    cursor: not-allowed;
  }
`

const secondary = css`
  background-color: ${({theme}) => theme.white};
  color: ${({theme}) => theme.colors.blue11};
  border: 1px solid ${({theme}) => theme.colors.grey7};
  &:hover {
    color: ${({theme}) => theme.colors.blue12};
    background-color: ${({theme}) => theme.colors.grey4};
  }
  &:active {
    color: ${({theme}) => theme.colors.blue13};
    background-color: ${({theme}) => theme.colors.grey5};
  }
  &:disabled {
    cursor: not-allowed;
    color: ${({theme}) => theme.colors.grey11};
  }
`

const tertiary = css`
  ${secondary}
  border: none;
  color: ${({theme}) => theme.colors.blue11};
  background-color: ${({theme}) => theme.colors.grey3};
`

const transparent = css`
  ${secondary}
  border: none;
  background-color: transparent;
  &:hover {
    background-color: ${({theme}) => theme.colors.greyA4};
  }
  &:active {
    background-color: ${({theme}) => theme.colors.greyA5};
  }
`

export type ButtonProps = {
  isRaised?: boolean
  isRounded?: boolean
  appearance?: 'primary' | 'secondary' | 'tertiary' | 'transparent'
  size?: 'xsmall' | 'small' | 'medium' | 'large'
  fontWeight?: 'bold' | 'medium' | 'regular'
}

export const Button = styled.button<ButtonProps>`
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  text-align: inherit;

  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  font-style: normal;
  border-radius: 4px;

  svg {
    color: inherit;
  }

  ${props => {
    switch (props.appearance) {
      case 'secondary':
        return secondary
      case 'tertiary':
        return tertiary
      case 'transparent':
        return transparent
      default:
        return primary
    }
  }}

  ${props => (props.isRaised ? raised : null)}
  ${props => (props.isRounded ? rounded : null)}
  ${props => {
    switch (props.size) {
      case 'xsmall':
        return xsmall
      case 'small':
        return small
      case 'medium':
        return medium
      case 'large':
        return large
      default:
        return small
    }
  }}
`

export const ButtonSecondary = styled(Button).attrs({appearance: 'secondary'})``

export const ButtonIcon = styled(Button)`
  border-radius: 999px;

  ${props => {
    switch (props.size) {
      case 'xsmall':
        return css`
          width: 20px;
          height: 20px;
          padding: 0px;
        `
      case 'medium':
        return css`
          width: 30px;
          height: 30px;
          padding: 0px;
        `
      case 'large':
        return css`
          width: 40px;
          height: 40px;
          padding: 0px;
        `
      case 'small':
      default:
        return css`
          width: 24px;
          height: 24px;
          padding: 0px;
        `
    }
  }}
`

export const ButtonGroup = styled.div`
  display: flex;

  /* allow submit button to be first in tab order */
  flex-direction: row-reverse;
  justify-content: flex-start;

  gap: 10px;
`

export const LinkButton = styled(Button).attrs({
  as: Link
})<LinkProps>``
